import React from 'react';
import ReactDOM from 'react-dom/client';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import {GlobalProvider} from "./GlobalContext";
import App from './App';
import reportWebVitals from './reportWebVitals';
import theme from './theme';
import { BrowserRouter } from 'react-router-dom';


import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {GoogleOAuthProvider} from "@react-oauth/google";

const root = ReactDOM.createRoot(

  document.getElementById('root') as HTMLElement
);
root.render(
<GoogleOAuthProvider clientId="1008031957867-34j8078v2e2t82379imsseac84jd0tg4.apps.googleusercontent.com">
  <React.StrictMode>
    <GlobalProvider>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
          <CssBaseline />
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </GlobalProvider>
  </React.StrictMode>
</GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
